import React, { PropsWithChildren } from 'react'

export const TooltipChildren = React.forwardRef((props:PropsWithChildren<any>, ref) => {
  //  Spread the props to the underlying DOM element.
  return (
    <div
      {...props}
      ref={ref as any}
    >
      <>
        {props.children}
      </>
    </div>
  )
})

TooltipChildren.displayName = 'TooltipChildren'
